export default __webpack_public_path__ + "static/media/Soliddäck Nåtad Teak.a809d23d.JPG";